import { ClinicalJudgement } from '../../../pages/eligibility/types';
import { ApiMessage, ApiResponseHandler } from '../../ApiResponseHandler';
import ThomApiClient from '../../ThomApiClient';

export const getClientClinicalJudgementDetails = async (
  evalId: string,
): Promise<ClinicalJudgement> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<ClinicalJudgement>(
      `clinical-judgment?evaluationId=${evalId}`,
    ),
  );
};

export const saveClinicalJudgement = async (
  evalId: string,
  value: ClinicalJudgement,
): Promise<ApiMessage> => {
  const url = value.id
    ? `clinical-judgment/${value.id}?evaluationId=${evalId}`
    : `clinical-judgment?evaluationId=${evalId}`;

  if (value.id) {
    // Update existing record
    return ApiResponseHandler(
      await ThomApiClient.getInstance().put<ClinicalJudgement, ApiMessage>(
        url,
        value,
      ),
    );
  } else {
    // Create new record
    return ApiResponseHandler(
      await ThomApiClient.getInstance().post<ClinicalJudgement, ApiMessage>(
        url,
        value,
      ),
    );
  }
};

export const deleteTeamMemberById = async (
  teamMemberId: string,
): Promise<ApiMessage> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete<ApiMessage>(
      `clinical-judgment/teams?teamMemberId=${teamMemberId}`,
    ),
  );
};

export const deleteConcernById = async (
  concernId: string,
): Promise<ApiMessage> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete<ApiMessage>(
      `clinical-judgment/concerns?concernId=${concernId}`,
    ),
  );
};
